export default "__VITE_ASSET__db4f6d1f__"